module.exports = __webpack_public_path__ + "static/media/super.f894217b.png";